import { Button } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import HtmlText from 'presentation/components/shared/HtmlText/HtmlText';
import downloadFile from 'presentation/utils/downloadFile';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  description: string;
  presentationUrl: string | null;
  title: string | null;
}

const EventDetailDescription: FC<Props> = ({
  description,
  presentationUrl,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{title ?? t('eventDescription')}</GridHeading>
      <AppCard p="20px">
        <HtmlText text={description} />
        {presentationUrl && (
          <Button mt="10px" onClick={() => downloadFile(presentationUrl)}>
            {t('eventDownloadPresentation')}
          </Button>
        )}
      </AppCard>
    </>
  );
};

export default EventDetailDescription;
